import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { ucgFiber } from './products/ucgFiber.mjs';
import { ucgMax } from './products/ucgMax.mjs';
import { ucgUltra } from './products/ucgUltra.mjs';
import './properties/index.mjs';
import { maxWanPortCount } from './properties/maxWanPortCount.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { unifiAppSuite } from './properties/unifiAppSuite.mjs';
import { managedUnifiDevices } from './properties/managedUnifiDevices.mjs';
import { simultaneousUsersConnected } from './properties/simultaneousUsersConnected.mjs';
import { throughput } from './properties/throughput.mjs';
import { idsIpsThroughput } from './properties/idsIpsThroughput.mjs';
import { portLayout } from './properties/portLayout.mjs';
import { storage } from './properties/storage.mjs';
import { mounting } from './properties/mounting.mjs';
"use strict";
const GatewaysCompact = {
  properties: [dimensions, unifiAppSuite, managedUnifiDevices, simultaneousUsersConnected, throughput, idsIpsThroughput,
  // wanPorts,
  maxWanPortCount,
  // lanPorts,
  portLayout, storage, mounting],
  products: [ucgFiber, ucgMax, ucgUltra],
  columnWidth: TABLE_COLUMN_WIDTH
};
export { GatewaysCompact };
//# sourceMappingURL=GatewaysCompact.mjs.map
